import { schema } from "normalizr";

const CustomFieldSchema = new schema.Entity("customFields");
const CustomFieldArraySchema = new schema.Array(CustomFieldSchema);

export { CustomFieldSchema, CustomFieldArraySchema };